// extracted by mini-css-extract-plugin
export var discard = "_3b-3";
export var muiTooltipTooltip = "_3b-5";
export var notificationBar = "_3b-2";
export var saveButtonHoverSlotWrapper = "_3b-4";
export var show = "_3b-1";
export var spacer = "_3b-0";